<template>
  <div>
    <div class="home-bottom">
      <div class="home-bottom-left">
        <div class="home-bottom-left-content">
          <p class="home-bottom-left-content-title">合作.共创.共享.共赢</p>
          <p class="home-bottom-left-content-text">
            1.合益开放平台，期待与您的相遇，共创未来
          </p>
          <p class="home-bottom-left-content-text">
            2.优质的商品、一流的服务是我们对你的承诺
          </p>
          <p class="home-bottom-left-content-text">
            3.我们为您提供最好的创业平台，诚信为本、快捷服务
          </p>
          <p class="home-bottom-left-content-text">
            4.打造共创、共享、共赢全面合作模式，人人参与，打造绿色商业生态生命共同体
          </p>
        </div>
        <div class="beian">
          <img class="beianimg" src="../../assets/img/jinghui2.png" alt="" />
          <el-button type="text" style="height: 50px;margin-left: 10px;background-color:#222;font-size: 18px;color: aliceblue;" onclick="javascrtpt:window.location.href='https://beian.miit.gov.cn'">网站备案号：蜀ICP备2023025266号-1号@2010 电商.物流.智能</el-button>       
        </div>
      </div>
      <div class="home-bottom-right">
        <p class="home-bottom-right-content-title">联系方式</p>
        <div class="home-bottom-right-content">
          <div class="home-bottom-right-content-left">
            <p class="home-bottom-right-content-text">
              <img
                class="home-icon"
                src="../../assets/img/weichat1.png"
                alt=""
              />
              <span>客户中心</span>
            </p>
            <p class="home-bottom-right-content-text">
              <img class="home-icon" src="../../assets/img/tel1.png" alt="" />
              <span>95362</span>
            </p>
          </div>
          <div class="home-bottom-right-content-right">
            <p class="home-bottom-right-content-icon">
              <img
                class="wechaticon"
                src="../../assets/img/gzh.jpg"
                alt=""
              />
            </p>
            <p style="color:#fff;margin-left: 16%;">进入公众号</p>
          </div>
        </div>
      </div>
    </div>
    <!-- <el-footer class="home-bottom">底部</el-footer> -->
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.home-bottom {
  width: 100%;
  // height: 200px;
  background-color: #222;
  display: flex;
  justify-content: left;

  .home-bottom-left {
    padding-top: 30px;
    padding-left: 10%;

    .home-bottom-left-content {
      .home-bottom-left-content-title {
        color: #fff;
        font-size: 22px;
      }
      .home-bottom-left-content-text {
        margin-top: 15px;
        color: rgb(144, 142, 142);
        font-size: 16px;
      }
    }

    .beian {
      // margin-top: 5px;
      padding-top: 20px;
      display: flex;
      align-items: center;
      padding-bottom: 10px;

      .beianimg {
        width: 70px;
        height: 50px;
      }

      span {
        color: #fff;
        // margin-left: 3px;
      }
    }
  }
  .home-bottom-right {
    padding-top: 30px;
    margin-left: 15%;

     .home-bottom-right-content-title {
        color: #fff;
        font-size: 22px;
      }

    .home-bottom-right-content {
      display: flex;
     

      .home-bottom-right-content-left {
        .home-bottom-right-content-text {
          margin-top: 15px;
          color: rgb(144, 142, 142);
          font-size: 16px;
          display: flex;
          align-items: center;

          .home-icon {
            width: 30px;
            height: 30px;
          }

          span {
            margin-left: 5%;
          }
        }
      }
      .home-bottom-right-content-right {
        margin-left: 20%;
        .home-bottom-right-content-icon {
          .wechaticon {
            width: 120px;
            height: 120px;
          }
        }
      }
    }
  }
}
</style>